import React from "react";
import { useLocation } from "react-router-dom";
import QRCode from "react-qr-code";
import CryptoJS from "crypto-js";
import LZString from "lz-string";
import { useReactToPrint } from "react-to-print";

export default function QRCDOffline() {
  const SECRET_KEY = "HONNEUR_DE_LA_PATRIE";
  const contentRef = React.useRef(null);
  const { state } = useLocation();
  const vehicule = state?.vehicule;

  const encryptData = (input) => {
    const buildMinimal = (source) => {
      const minimal = {
        n: source?.nom,
        p: source?.prenom,
        f: source?.franchise,
        c: source?.chassis,
        co: source?.couleur,
        u: source?.usage,
        t: source?.type ?? source?.type_vehicule,
      };
      return Object.fromEntries(
        Object.entries(minimal).filter(([, v]) => v !== undefined && v !== null)
      );
    };

    const uint8ArrayToWordArray = (u8Array) => {
      const words = [];
      for (let i = 0; i < u8Array.length; i += 4) {
        words.push(
          ((u8Array[i] || 0) << 24) |
            ((u8Array[i + 1] || 0) << 16) |
            ((u8Array[i + 2] || 0) << 8) |
            (u8Array[i + 3] || 0)
        );
      }
      return CryptoJS.lib.WordArray.create(words, u8Array.length);
    };

    const toBase64Url = (b64) => b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");

    const minimal = buildMinimal(input);
    const json = JSON.stringify(minimal);
    const compressed = LZString.compressToUint8Array(json);
    const wordArray = uint8ArrayToWordArray(compressed);
    const cipherB64 = CryptoJS.AES.encrypt(wordArray, SECRET_KEY).toString();
    return toBase64Url(cipherB64);
  };

  const encryptedData = encryptData(vehicule);
  const handlePrint = useReactToPrint({ contentRef });

  return (
    <div className="ml-[5%] w-[90%] h-[100%] flex flex-col items-center text-black absolute mt-[15%] p-3">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('/niger22.jpg')" }}></div>
      <div className="relative w-[100%] justify-between overflow-y-scroll p-2 rounded-md text-black bg-opacity-95">
        <div className="flex flex-row w-[100%] justify-between pt-11 items-start gap-4 p-4 border rounded-lg shadow-lg bg-white bg-opacity-70">
          <div>
            <h2 className="text-xl font-bold">Informations du propriétaire (Hors ligne)</h2>
            <div className="alert alert-warning mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
              <span>Ces données sont enregistrées localement et seront synchronisées lorsque la connexion sera rétablie</span>
            </div>

            <p className="text-md font-medium flex flex-row">Nom de Famille: <b>{vehicule.nom}</b></p>
            <p className="text-md font-medium"> Prenom: <b>{vehicule.prenom}</b></p>
            <p className="text-md font-medium">Telephone: <b>{vehicule.telephone} </b></p>
            <h2 className="text-xl font-bold">Informations du vehicule</h2>
            <p className="text-md font-medium">Numéro de serie: <b>{vehicule.numero_serie_plaque}</b></p>
            <p className="text-md font-medium">Usage: <b>{vehicule.usage}</b> </p>
            <p className="text-md font-medium">Type/Couleur:<b> {vehicule.couleur}</b></p>
            <p className="text-md font-medium">Franchise:<b> {vehicule.franchise}</b></p>
            <p className="text-md font-medium">Numéro de chassis: <b>{vehicule.chassis}</b></p>
            <p className="text-md font-medium">Date d'émission: <b>{vehicule.date_creation}</b></p>
            <p className="text-md font-medium">Station: <b>{vehicule.code_station}</b></p>
          </div>
          <div>
            <div className="flex flex-row justify-between items-center m-5">
              <h2 className="text-xl font-bold">QR Code du véhicule (Hors ligne)</h2>
              <button
                onClick={() => handlePrint()}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
              >
                Imprimer QR Code
              </button>
            </div>
            <div
              ref={contentRef}
              className="print-wrapper"
              style={{
                width: "37mm", // Largeur de l'étiquette
                height: "42mm", // Hauteur de l'étiquette
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                backgroundColor: "#fff",

                boxSizing: "border-box",
                marginTop: "0mm",
                paddingTop: "5mm",
                // À retirer en prod
              }}
            >
              {/* Contenu principal */}
              <div
                style={{
                  width: "90%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignContent:"flex-start",
                  alignItems:"flex-start",
                  gap: "1mm",

                }}
              >
                {/* Colonne de gauche (texte) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flex: "1",
                  }}
                >
                  <div style={{ marginBottom: "1mm", marginLeft: "2mm", display: "flex", flexDirection: "row", width: "20mm", gap: "1.4mm" }}>
                    <QRCode value={vehicule.numero_serie_plaque?.toUpperCase() || "Valeur manquante"} size={28} />

                    <p
                      style={{
                        fontSize: "1.3mm",
                        fontWeight: "bold",
                        marginTop: "1mm",
                        fontFamily: "Arial Black",
                        color: "#000",
                        width:"10mm",
                        overflowWrap:"break-word"
                      }}
                    >
                      {vehicule.numero_serie_plaque?.toUpperCase()}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.14mm",
                      marginLeft: "1mm",
                    }}
                  >
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicule.couleur?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicule.franchise?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                      width:"19mm",
                      overflowWrap:"break-word"
                    }}>
                      {vehicule.chassis?.toUpperCase()}
                    </p>
                  </div>
                </div>
                {/* QR Code principal (droite) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "flex-start",

                  }}
                >
                  <QRCode
                    value={encryptedData || "Valeur manquante"}
                    size={45} // Augmente la taille pour une meilleure netteté
                    level="M"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                  />
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignContent:"flex-start",
                  alignItems:"flex-start",
marginTop: "4mm",

                }}
              >
                {/* Colonne de gauche (texte) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flex: "1",
                  }}
                >
                  <div style={{ marginBottom: "1mm", marginLeft: "2mm", display: "flex", flexDirection: "row", width: "20mm", gap: "1.4mm" }}>
                    <QRCode value={vehicule.numero_serie_plaque?.toUpperCase() || "Valeur manquante"} size={28} />

                    <p
                      style={{
                        fontSize: "1.3mm",
                        fontWeight: "bold",
                        marginTop: "1mm",
                        fontFamily: "Arial Black",
                        color: "#000",
                        width:"10mm",
                        overflowWrap:"break-word"
                      }}
                    >
                      {vehicule.numero_serie_plaque?.toUpperCase()}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.14mm",
                      marginLeft: "1mm",
                    }}
                  >
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicule.couleur?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                    }}>
                      {vehicule.franchise?.toUpperCase()}
                    </p>
                    <p style={{
                      fontSize: "1.3mm",
                      fontWeight: "bold",
                      fontFamily: "Arial Black",
                      color: "#000",
                      width:"19mm",
                      overflowWrap:"break-word"
                    }}>
                      {vehicule.chassis?.toUpperCase()}
                    </p>
                  </div>
                </div>
                {/* QR Code principal (droite) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "left",
                    justifyContent: "flex-start",

                  }}
                >
                  <QRCode
                    value={encryptedData || "Valeur manquante"}
                    size={45} // Augmente la taille pour une meilleure netteté
                    level="M"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                  />
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
